import React, { ChangeEvent, FunctionComponent, useContext } from "react";
import { Choice } from "@cmsgov/ds-medicare-gov";
import { useTranslate } from "../../helpers";
import { Plan, SearchResultPlan } from "../../@types";
import { AppContext } from "../../app/store";
import { isCurrentPlan } from "../../helpers/beneficiaryInfoHelpers";

interface AddToCompareProps {
  hide?: boolean;
  plan: SearchResultPlan;
  handleAddToCompare?: (plan: SearchResultPlan) => void;
  handleRemoveFromCompare?: (removeId: number | string) => void;
}

const AddToCompare: FunctionComponent<AddToCompareProps> = ({
  hide,
  plan,
  handleAddToCompare,
  handleRemoveFromCompare,
}) => {
  const {
    state: { compareList },
  } = useContext(AppContext);

  const isSelected = !!compareList.find((item: Plan | SearchResultPlan) =>
    isCurrentPlan(item, plan)
  );

  const t = useTranslate();

  return (
    <>
      {!hide && (
        <Choice
          type="checkbox"
          value="add"
          checked={isSelected}
          name={`add_to_compare_${plan.id}`}
          className="e2e-compare-plan"
          onChange={(e: ChangeEvent<HTMLInputElement>): void => {
            if (e.target.checked) {
              handleAddToCompare ? handleAddToCompare(plan) : null;
            } else {
              handleRemoveFromCompare ? handleRemoveFromCompare(plan.id) : null;
            }
          }}
        >
          {isSelected ? t("added") : t("add")}{" "}
          {t("plan_compare_footer.to_compare")}
        </Choice>
      )}
    </>
  );
};

export default AddToCompare;
